import { render } from "./SortableQuestion.vue?vue&type=template&id=d69f8e46"
import script from "./SortableQuestion.vue?vue&type=script&lang=js"
export * from "./SortableQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__